import React from 'react';
import { latestRejection } from './StatusActionsCard';
import { latestFieldComments } from './fieldComments';

// 「上一次退件的整體理由」——放在每一個 Modify modal 的最上面。
//
// 申請者要改的地方就是這張 modal，而審核者的理由在 Detail 頁上。少了這一塊，
// 每個人都得先把它抄下來、關掉頁面、再打開 modal 憑記憶改。
//
// **逐項意見不列在這裡**：若把每一則都堆在這一塊，
// 要改第七題就得往上捲讀、再往下捲改，一題來回兩趟。每一則長在它
// 講的那一格底下（FormKit 的 `Field` 帶 `field=`），這裡只留下不屬於任何
// 一格的那句整體理由，以及一行「下面每一格都有」的指路。
//
// 沒有被退過就整塊不顯示，所以每一頁都可以無條件掛上去。
const ReturnCommentsBanner = ({ events = [] }) => {
  const returned = latestRejection(events);
  if (!returned) return null;
  const comments = latestFieldComments(events);

  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-3">
      <div className="min-w-0">
        <p className="text-xs font-semibold text-red-800 uppercase tracking-wide">
          What the reviewer asked for
        </p>
        <p className="text-sm text-red-900 mt-1 whitespace-pre-wrap break-words">{returned.reason}</p>
        {comments.length > 0 && (
          <p className="text-xs text-red-700 opacity-80 mt-1.5">
            {comments.length} entr{comments.length === 1 ? 'y has' : 'ies have'} a comment — each one is shown
            under the field it refers to.
          </p>
        )}
      </div>
    </div>
  );
};

export default ReturnCommentsBanner;
